export function buscarExercicio() {
  return new Promise(async (resolve, _reject) => {
    window.$http.get("/exercicios").then((res) => {
      resolve(res);
    });
  });
}

export function buscarParametroExercicio() {
  return new Promise(async (resolve, _reject) => {
    window.$http.get("/parametroexerciciosrag/all").then((res) => {
      resolve(res);
    });
  });
}

export function buscarQuestionarios(sistema) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/questsistemas/sistema/ativos/${sistema}`).then((res) => {
      resolve(res);
    });
  });
}

export function copyQuestionarios(itemRag, idenParametroExercicioOrigem, idenParametroExercicioDestino) {
  return new Promise(async (resolve, _reject) => {
    window.$http
      .get(
        `/parametroexerciciosrag/copyquiz/${itemRag}/${idenParametroExercicioOrigem}/${idenParametroExercicioDestino}`
      )
      .then((res) => {
        resolve(res);
      });
  });
}

export function cadastraExercicioRag(paramentroExercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/parametroexerciciosrag`, JSON.stringify(paramentroExercicio)).then((res) => {
      resolve(res);
    });
  });
}

export function atualizarExercicioRag(idenParametroExercicio, paramentroExercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http
      .put(`/parametroexerciciosrag/${idenParametroExercicio}`, JSON.stringify(paramentroExercicio))
      .then((res) => {
        resolve(res);
      });
  });
}

export function cronogramaAllFase() {
  return new Promise(async (resolve, _reject) => {
    window.$http.get("/fases/all").then((res) => {
      resolve(res);
    });
  });
}

export function createCronogramaRag(cronograma) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/cronogramas`, JSON.stringify(cronograma)).then((res) => {
      resolve(res);
    });
  });
}

export function atualizarCronogramaRag(idenCronograma, cronograma) {
  return new Promise(async (resolve, _reject) => {
    window.$http.put(`/cronogramas/${idenCronograma}`, JSON.stringify(cronograma)).then((res) => {
      resolve(res);
    });
  });
}

export function excluirCronogramaRag(idenCronograma) {
  return new Promise(async (resolve, _reject) => {
    window.$http.delete(`/cronogramas/${idenCronograma}`).then((res) => {
      resolve(res);
    });
  });
}

export function getParametroExercicio(idenParametroExercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/parametroexerciciosrag/${idenParametroExercicio}`).then((res) => {
      resolve(res);
    });
  });
}

export function getAllOrgao(idenExercicio) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/arvoresrag/orgaos/${idenExercicio}`).then((res) => {
      resolve(res);
    });
  });
}

export function getAllUo(idenUo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/arvoresrag/uos/${idenUo}`).then((res) => {
      resolve(res);
    });
  });
}

export function getAllPrograma(idenOrgao, idenUo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/arvoresrag/visoes/${idenOrgao}/${idenUo}`).then((res) => {
      resolve(res);
    });
  });
}

export function getAllProgramaV1(idenOrgao, idenUo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/v1/arvoresrag/visoes/${idenOrgao}/${idenUo}`).then((res) => {
      resolve(res);
    });
  });
}

export function getObjetivo(idenPtaFiplan) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/ptamonitoras/buscarPeloIdenPtaFiplan/${idenPtaFiplan}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarPorExercicioTipoItem(queryParams) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/prorrogacaorags/buscarPorExercicioTipoItem`, JSON.stringify(queryParams)).then((res) => {
      resolve(res);
    });
  });
}

export function updateItemProrrogacao(idenProrrogacao, itemProrrogacao) {
  return new Promise(async (resolve, _reject) => {
    window.$http.put(`/prorrogacaorags/${idenProrrogacao}`, JSON.stringify(itemProrrogacao)).then((res) => {
      resolve(res);
    });
  });
}

export function changeStatusProrrogacao(itemProrrogacao) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/prorrogacaorags/alterarStatus`, JSON.stringify(itemProrrogacao)).then((res) => {
      resolve(res);
    });
  });
}

export function createProrrogacao(dadosProrrogacao) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/prorrogacaorags`, JSON.stringify(dadosProrrogacao)).then((res) => {
      resolve(res);
    });
  });
}
